export default __webpack_public_path__ + "static/media/canada.e3b17403.svg";